<template>
  <div :class="wrapper_class">
    <comment
      v-if="elementData.type !== 'FbVideo'"
      :element-uuid="elementData.uuid"
      :submission-uuid="submissionUuid"
      :submission-view-mode="true"
    />
    <div v-if="['FbCheckbox', 'FbRadioButton', 'FbSelect'].indexOf(elementData.type) == -1" class="element-label">{{ elementData.label | token_replace(nid) }}</div>
    <div v-if="['FbCheckbox', 'FbRadioButton', 'FbSelect'].indexOf(elementData.type) !== -1">
      <div class="activity-submission-item" v-if="selectedOptions(true).length">
        <div class="element-content">
          <div class="element-label">{{ elementData.label | token_replace(nid) }}</div>
          <ul class="item-list">
            <li
              :key="index"
              v-for="(option, index) in selectedOptions()"
              :data-value="option.value"
              :data-checked="+option.checked"
              class="list-item"
            >{{ option.label }}</li>
          </ul>
          <div v-if="elementData.value.other_text" class="item-other">
            <span>Other:</span>
            {{ elementData.value.other_text }}
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="elementData.type === 'FbStarRating'" class="element-content">
      <star-rating
        :rating="elementData.value"
        :read-only="true"
        :increment="parseInt(elementData.increment)"
        :max-rating="parseInt(elementData.max_rating)"
        :star-size="24"
        :rounded-corners="true"
        active-color="#ffa300"
        inactive-color="#ffffff"
        :border-width="6"
        border-color="#ffa300"
      ></star-rating>
    </div>
    <div v-else-if="elementData.type === 'FbLikert'" class="element-content likert-wrapper">
      <div
        v-bind:key="index"
        v-for="(option, index) in elementData.sections"
        class="md-layout-item likert-item"
      >
        <div class="md-layout-item md-toolbar-section-start">
          <div class="md-layout-item">
            <md-field :class="messageClass" class="label-top">
              <h5>{{option.label}}</h5>
            </md-field>

            <vue-slider
              v-model="elementData.value[option.label]"
              :data="elementData.options_set"
              :marks="true"
              :tooltip-placement="'bottom'"
              :useKeyboard="true"
            ></vue-slider>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="elementData.type === 'FbFile'" class="element-content">
      <div v-for="item in elementData.value" class="link-item">
        <a v-if="item.type === 'link'" :href="item.link" target="_blank">{{ item.link }}</a>
        <a v-if="item.type === 'file'" :href="item.uri" target="_blank">{{ item.name }}</a>
      </div>
    </div>
    <div v-else-if="elementData.type === 'FbVideo'" class="element-content">
      <div :key="item.uuid" v-for="item in elementData.value" class="video-item video-uploaded">
        <video controls preload="auto" :ref="item.uuid" class="video-js vjs-has-started"></video>
      </div>
    </div>
    <div v-else-if="elementData.type === 'FbHtmlPackage'" class="element-content">
      <div class="h5p-element">
        <span v-if="elementData.value.response" class="response">
          <span v-if="elementData.value.success.value" class="success"></span>
          <span v-else class="failure"></span>
          {{ elementData.value.response.value }}
        </span>
        <span v-else class="score">
          Score: {{ elementData.value.result.value }}%
        </span>

      </div>
      <!--<ul class="item-list">
        <li :key="item.uuid" v-for="item in elementData.value" class="list-item">
          <span>{{ item.title }}:</span> {{ item.value }}
        </li>
      </ul>-->
    </div>
    <div v-else-if="elementData.type === 'FbQuiz'" class="element-content">
      <div class="quiz-element">
        <div v-if="elementData.value.completion">
          <div class="item-list">
            <span class="success"></span><span>Evaluated</span>
          </div>
          <quiz-results-table :results="quiz_results"></quiz-results-table>
        </div>
        <div v-else><span class="failure"></span></div>
      </div>
    </div>
    <div v-else-if="elementData.type === 'FbScorm'" class="element-content">
      <div class="quiz-element">
        <div v-if="elementData.value['cmi.completion_status'] && ['passed', 'completed'].indexOf(elementData.value['cmi.completion_status']) !== -1 || elementData.value['cmi.core.lesson_status'] && ['passed', 'completed'].indexOf(elementData.value['cmi.core.lesson_status']) !== -1">
          <div class="item-list">
            <span class="success"></span><span>Completed</span>
          </div>
        </div>
        <div v-else><span class="failure"></span></div>
      </div>
    </div>
    <div v-else class="element-content">{{ elementData.value }}</div>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import VueSlider from "vue-slider-component";
import videojs from "video.js";
import "video.js/dist/video-js.min.css";
import Comment from "./components/Comment";
window.$ = window.jQuery;
import AnnotationComments from "@dbuzinov/videojs-annotation-comments/build/videojs-annotation-comments.cjs.js";
import "@dbuzinov/videojs-annotation-comments/build/css/annotations.css";
import HelpersMixin from "./HelpersMixin";
import VideoCommentMixin from "./VideoCommentMixin";
import QuizMixin from './QuizMixin';
import QuizResultsTable from './QuizResultsTable';

export default {
  name: "ActivitySubmissionElement",
  props: ["elementData", "allowCommenting"],
  components: {
    StarRating,
    VueSlider,
    Comment,
    QuizResultsTable,
    QuizResultsTable
  },
  mixins: [HelpersMixin, VideoCommentMixin, QuizMixin],
  mounted() {
    if (this.elementData.type === "FbVideo") {
      this.elementData.value.forEach(async (item) => {
        let comments = await this.getComments(item.uuid);
        try {
          videojs.registerPlugin(
            "annotationComments",
            AnnotationComments(videojs)
          );
          let options = {
            controls: true,
            fluid: true,
            sources: [
              {
                src: item.uri,
                type: item.filemime,
              },
            ],
          };
          if (this.$refs[item.uuid] && this.$refs[item.uuid][0]) {
            this.player[item.uuid] = videojs(
              this.$refs[item.uuid][0],
              options,
              () => {
                // annotationDeleted : Fired when an annotation has been deleted via the UI
                this.plugin[item.uuid].registerListener(
                  "annotationDeleted",
                  (event) => {
                    let annotationUuid = event.detail.id;
                    let elementUuid = item.uuid;
                    this.deleteAnnotation(elementUuid, annotationUuid);
                  }
                );
                this.plugin[item.uuid].registerListener(
                  "onStateChanged",
                  (event) => {
                    // event.detail = annotation state data
                    let currentComment = {};
                    event.detail.forEach((annotation) => {
                      annotation.comments.map((comment) => {
                        currentComment[comment.id] = comment;
                        if (this.comments[comment.id]) {
                          return;
                        }
                        this.comments[comment.id] = comment;
                        //console.log(event, annotation);
                        this.setComment(
                          item.uuid,
                          comment.body,
                          {
                            annotation: annotation.id,
                            range: annotation.range,
                            shape: annotation.shape,
                            meta: comment.meta,
                          },
                          comment.id
                        );
                        // if (annotation.comments.lenght == 1) {
                        //   // First comment in annotation.
                        // }
                      });
                    });
                    let currentCommentIds = Object.keys(currentComment).map(
                      (comment) => {
                        return currentComment[comment].id;
                      }
                    );
                    let existingCommentIds = Object.keys(this.comments).map(
                      (comment) => {
                        return this.comments[comment].id;
                      }
                    );
                    let deleted = existingCommentIds.filter(
                      (x) => !currentCommentIds.includes(x)
                    );
                    deleted.map((id) => {
                      //console.log("comment deleted " + id);
                      //this.comments[comment];
                      this.deleteComment(id);
                      //delete this.comments[id];
                    });
                  }
                );
              }
            );

            let annotations = {};
            comments.forEach((comment) => {
              comment.attributes.meta = JSON.parse(
                comment.attributes.meta.value
              );
              if (!annotations[comment.attributes.meta.annotation]) {
                annotations[comment.attributes.meta.annotation] = {
                  id: comment.attributes.meta.annotation,
                  range: comment.attributes.meta.range,
                  shape: comment.attributes.meta.shape,
                  comments: [],
                };
              }
              let meta = comment.attributes.meta.meta;
              meta.user_name =
                comment.user.attributes.field_first_name +
                " " +
                comment.user.attributes.field_last_name;

              annotations[comment.attributes.meta.annotation].comments.push({
                id: comment.id,
                meta: meta,
                body: comment.attributes.comment.value,
              });
            });
            let annotationsObjects = Object.keys(annotations).map((key) => {
              return annotations[key];
            });
            annotationsObjects.map((annotation) => {
              annotation.comments.map((comment) => {
                this.comments[comment.id] = comment;
              });
            });
            if (
              comments.length ||
              window.drupalSettings.user.role == "coach" ||
              window.drupalSettings.user.role == "administrator" ||
              this.allowCommenting == true
            ) {
              this.plugin[item.uuid] = this.player[
                item.uuid
              ].annotationComments({
                annotationsObjects: annotationsObjects,
                meta: {
                  user_id: window.drupalSettings.user.uid,
                  user_name: window.drupalSettings.user.username,
                },
                bindArrowKeys: true,
                showControls: true,
                showCommentList: true,
                showFullScreen: true,
                showMarkerShapeAndTooltips: true,
                internalCommenting: true,
                startInAnnotationMode: true,
                permissionToDeleteComment: (comment) => {
                  return comment.meta.user_id == window.drupalSettings.user.uid;
                },
                permissionToDeleteAnnotation: function (comment_list) {
                  return (
                    window.drupalSettings.user.role == "administrator" ||
                    window.drupalSettings.user.role == "coach"
                  );
                },
              });
            }
          }
        } catch (error) {
          console.log(error);
        }
      });
    }
    if (this.elementData.type === "FbQuiz") {
      if (this.elementData.value.vid) {
        this.getQuizResults(this.elementData.value.vid, drupalSettings.activitySubmissionUid).then((res)=>{
          this.quiz_results = res;
        })
      }
    }
    if (['FbCheckbox', 'FbRadioButton', 'FbSelect'].indexOf(this.elementData.type) !== -1) {
      this.wrapper_class = '';
    }
  },
  methods: {
    selectedOptions(onlyChecked) {
      let selectedOption = [];
      for (let index = 0; index < this.elementData.value.options.length; index++) {
        const element = this.elementData.value.options[index];
        if (onlyChecked && element.checked && element.value != "") {
          selectedOption.push(element);
        }
        else if (!onlyChecked && element.value != "") {
          selectedOption.push(element);
        }
      }
      return selectedOption;
    }
  },
  data() {
    return {
      wrapper_class: 'activity-submission-item',
      loading: false,
      player: {},
      plugin: {},
      comments: {},
      quiz_results: [],
      nid: window.drupalSettings.node.uuid,
      submissionUuid:
        window.drupalSettings.activitySubmissionUuid ||
        window.drupalSettings.entityUuid,
      entity_type:
        window.drupalSettings.entityType ||
        this.getSubmission().entity_type ||
        null,
      entity_id:
        window.drupalSettings.entityId ||
        this.getSubmission().entity_id ||
        null,
    };
  },
};
</script>
<style lang="scss" scoped>
.activity-submission-item {
  font-family: $font-source-sans-pro;
  color: #3c3c3c;
  font-size: 16px;
  padding-bottom: 20px;
  .element-label {
    font-weight: bold;
    padding-bottom: 10px;
  }
  .element-content {
    .item-list {
      list-style: none;
      padding: 0 0 16px 26px;
      padding-bottom: 0;
      li {
        margin-left: 0;
        &::before {
          content: "";
          display: inline-block;
          position: relative;
          height: 16px;
          top: 3px;
          width: 32px;
          background-image: url("assets/step_inactive.svg");
          background-repeat: no-repeat;
          background-position: center center;
        }
      }
      li[data-checked="1"]:before {
        background-image: url("assets/checked.svg");
      }
    }
    a {
      color: $blue-active;
      font-size: 16px;
      font-weight: normal;
      font-family: $font-source-sans-pro;
    }
    .success,
    .failure {
      display: inline-block;
      top: 3px;
      position: relative;
      width: 32px;
      height: 16px;
    }

    .success {
      background: url("assets/checked.svg") no-repeat center;
    }
    .failure {
      background: url("assets/cross.svg") no-repeat center;
    }

    .h5p-element {
      margin-left: 30px;
      .response {
        span {
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-right: 10px;
          top: 3px;
          position: relative;
        }
      }
      .score {
        background-color: #E8E7EE;
        padding: 5px 15px;
        border-radius: 3px;
        font-weight: bold;
      }

    }
  }
  .likert-wrapper {
    max-width: 500px;
  }
  .video-item {
    margin-bottom: 15px;
  }
  .list-item span {
    font-weight: bolder;
  }
}
.video-js.video-js {
  width: 100%;
  //background-color: #f5ecf8;
}
</style>
